
import { writable } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'

import type { AccountRolePermission } from './type'


let loaded_account_role_id: string = ''
const store = writable<AccountRolePermission[]>([])
export { store as account_role_permissions_store }


let promiseFetch: Promise<AccountRolePermission[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'


export const InitAccountRolePermissions = async (account_role_id: string, pFetch = fetch, force = false) => {

	// if SSR just return the promise data
	if (!browser) return fetchData(account_role_id, pFetch)
	if (account_role_id==='' || account_role_id===undefined) {
		store.set([])
		return true
	}

	if (loaded_account_role_id !== account_role_id) {
		loaded_account_role_id = account_role_id
		force = true
	}

	if (!force && state === 'ready') return
	if (!force && state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(account_role_id, pFetch)
	await promiseFetch
	return true
}

const fetchData = async (account_role_id: string, pFetch = fetch) => {
	if (browser) state = 'reading'

	const params = { account_role_id: account_role_id }
	const body = JSON.stringify(params)
	const jsonData = await apiFetchJson(pFetch, 'post', '/team/account_role_permissions', undefined, body)

	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return []
	}

	// const data = parseServer(jsonData)
	const data = jsonData.account_role_permissions
	if (browser) {
		store.set(data)
		state = 'ready'
	}

	
	return data
}
